import React, { useContext, useRef, useState } from 'react'
import { Button, ListMenu, ListMenuButton,
   NotificationManagerContext, Modal, Popover, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { MoreIcon } from 'assets/icons'
import DeleteConfirm from 'src/components/Initiative/DeleteConfirm'
import { useMe, useOrganization, useUpdateInitiative } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitiativeMoreButton = ({ color, iconColor }) => {
   const history = useHistory()
   const match = useRouteMatch()

   const popoverButton = useRef()
   const [modalIsOpen, setModalIsOpen] = useState(false)
   const [popoverIsOpen, setPopoverIsOpen] = useState(false)
   const { showNotification } = useContext(NotificationManagerContext)

   const { isLoggedIn } = useMe()
   const { organization } = useOrganization()
   const { initiative } = useContext(InitiativeHierarchyContext)
   const { updateInitiative, mutating } = useUpdateInitiative()
   const isActive = ['inherit', 'private', 'custom'].includes(initiative.privacy)
   const isOrganizationAdmin = organization.currentUserCanEdit

   if (!isLoggedIn || !initiative.currentUserCanEdit) {
      return null
   }

   const handleUpdateInitiative = async (value) => {
      try {
         await updateInitiative({ id: initiative.id }, value)

         showNotification({
            message: `${initiative.type.nameSingular} updated successfully`,
            title: 'Success!',
            type: 'success'
         })
      } catch (err) {
         showNotification({
            message: err.message,
            title: 'Error!',
            type: 'error'
         })
      }
   }

   return (
      <View marginLeft="3px">
         <Button
            ref={popoverButton}
            color={mutating ? '#666' : color}
            mode={mutating ? 'loading' : 'normal'}
            onClick={() => setPopoverIsOpen(true)}
            size="md"
            width="36px">
            <MoreIcon width="18px" height="18px" color={iconColor} />
         </Button>
         <Popover
            anchorElement={popoverButton.current}
            anchorOriginHorizontal="right"
            anchorOriginVertical="bottom"
            borderRadius="6px"
            width="210px"
            onBodyClick={() => setPopoverIsOpen(false)}
            open={popoverIsOpen}>
            <View
               float="left"
               width="100%"
               borderRadius="6px"
               margin="12px 0px"
               backgroundColor="#fff"
               border="1px solid #eee"
               boxShadow="6px 6px 30px rgba(0,0,0,0.1)">
               <View
                  float="left"
                  width="100%">
                  <ListMenu buttonSize="md" dividerLineStyle="none">
                     <ListMenuButton
                        linkTo={`${match.url}/settings`}
                        name={`Edit this ${initiative.type.nameSingular}`}
                     />
                     {isOrganizationAdmin && isActive && (
                        <ListMenuButton
                           onClick={() => {
                              handleUpdateInitiative({
                                 pinned: !initiative.pinned
                              })
                           }}
                           name={initiative.pinned
                              ? `Un-pin ${initiative.type.nameSingular}`
                              : `Pin ${initiative.type.nameSingular}`
                           }
                        />
                     )}
                     {initiative.class === 'discussion' && isActive && (
                        <ListMenuButton
                           onClick={() => {
                              handleUpdateInitiative({
                                 discussionStatus: {
                                    closed: !initiative.discussionStatus.closed
                                 }
                              })
                           }}
                           name={initiative.discussionStatus.closed
                              ? `Re-open ${initiative.type.nameSingular}`
                              : `Close this ${initiative.type.nameSingular}`
                           }
                        />
                     )}
                     <ListMenuButton
                        onClick={() => setModalIsOpen(true)}
                        name={`Delete this ${initiative.type.nameSingular}`}
                     />
                  </ListMenu>
               </View>
            </View>
         </Popover>
         <Modal
            borderRadius="6px"
            width="90%[a-b] 300px[c-f]"
            onCloseTrigger={() => setModalIsOpen(false)}
            open={modalIsOpen}>
            <DeleteConfirm
               initiativeId={initiative.id}
               initiativeName={initiative.name}
               onCancelButtonClick={() => setModalIsOpen(false)}
               // TODO: This is temporary until we figure out a better place to redirect
               // to when initiatives are deleted
               // See PR: #455
               onDelete={() => history.push('/profile')}
            />
         </Modal>
      </View>
   )
}

InitiativeMoreButton.propTypes = {
   color: PropTypes.string,
   iconColor: PropTypes.string
}

InitiativeMoreButton.defaultProps = {
   color: '#eee',
   iconColor: '#444'
}

export default InitiativeMoreButton
